import { render } from "./BaseTemporalFilter.vue?vue&type=template&id=5d83f96e"
import script from "./BaseTemporalFilter.vue?vue&type=script&lang=js"
export * from "./BaseTemporalFilter.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__